import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import {
	getIndicatorClassificationColorClassName,
	IndicatorEmultiEnum,
} from "@/utils/indicatorsEmulti";
import { ResumeIndicatorM1Data } from "@/services/esus/indicator/emulti/m1/getResumeIndicatorM1";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEmultiM1ResumeProps = {
	resume: ResumeIndicatorM1Data;
};

export function IndicatorEmultiM1Resume({ resume }: Readonly<IndicatorEmultiM1ResumeProps>) {
	const indicatorAverage = calculatePercentage(
		resume.totalAttendances / 100,
		resume.totalCitizens
	);

	return (
		<Row className="mx-0">
			<Col sm={12} lg={4} className="mb-2">
				<CardInformative
					title="Total de atendimentos"
					value={resume.totalAttendances.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de atendimentos"
							message="Quantidade de atendimentos e atividades coletivas realizadas por emulti nos últimos 12 meses"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} lg={4} className="mb-2">
				<CardInformative
					title="Total de cidadãos atendidos"
					value={resume.totalCitizens.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de cidadãos atendidos"
							message="Quantidade de cidadãos distintos atendidos por emulti nos últimos 12 meses"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} lg={4} className="mb-2">
				<CardInformative
					title="Média de atendimentos por cidadão"
					value={`${indicatorAverage}`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEmultiEnum.M1,
						indicatorAverage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="Classificação"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Média de atendimentos e atividades coletivas realizadas em
								relação ao total <br />
								de cidadãos distintos atendidos por emulti nos últimos 12 meses.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
		</Row>
	);
}
